/** @jsxImportSource solid-js */
import emailValidator from "email-validator";
import { createTextInput } from "./text.solid";

export function createEmailInput({
  initial = "",
  label = "",
  placeholder = "",
  tooltip = null,
}) {
  const baseInput = createTextInput({ initial, label, placeholder, tooltip });
  const emailValid = () => {
    return (
      baseInput.value() !== "" && emailValidator.validate(baseInput.value())
    );
  };

  return {
    valid: emailValid,
    value: baseInput.value,
    reset: baseInput.reset,
    component: (
      <>
        {baseInput.component}
        {baseInput.value() !== "" && !emailValid() && (
          <strong class="text-status-error-fg p-2 hidden group-data-[validate=true]:block">
            Please enter a valid email address.
          </strong>
        )}
      </>
    ),
  };
}
